module.exports = __webpack_public_path__ + "img/back02.e6c874ad.png";